module.exports = __webpack_public_path__ + "static/media/orderDispatchedVariant.692a818a.svg";